// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useEffect, useRef } from 'react'

export default function useInfiniteScroll(fetchData: () => void, hasMore: boolean) {
  const observerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const currentRef = observerRef.current // Copy ref to a local variable

    const handleObserver = (entries: IntersectionObserverEntry[]) => {
      const target = entries[0]
      if (target.isIntersecting && hasMore) {
        fetchData()
      }
    }

    const observer = new IntersectionObserver(handleObserver, {
      root: null,
      rootMargin: '100px', // Increased margin to trigger fetch earlier
      threshold: 0.5, // Adjusted threshold to ensure fetchData is triggered reliably
    })

    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [fetchData, hasMore])

  return observerRef
}
